import React, { ReactChild } from 'react';
import styles from './index.scss';
import classNames from 'classnames';


type Props = {
  text?: string,
  subtext?: string,
  children?: string | ReactChild,
};

export const PageHeader = ({ text, children }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }
  return (
    <h2 className={styles.pageHeader}>
      {text || children}
    </h2>);
};

export const SectionHeader = ({ text, subtext, children }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }
  return (
    <React.Fragment>
      <h3 className={
        classNames(styles.sectionHeader, {
          [styles.withSubText]: subtext && subtext.length > 0,
        })}
      >
        {text || children}
      </h3>
      {subtext && (<span className={styles.subText}>{subtext}</span>)}
    </React.Fragment>);
};

export const SubsectionHeader = ({ text, children }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }
  return (
    <h4 className={styles.sectionHeader}>
      {text || children}
    </h4>);
};
